
/* import { PopupPicker } from 'vux'; */
import PopupPicker from 'vux/src/components/popup-picker/index.vue'

const getObject = function(obj) {
return JSON.parse(JSON.stringify(obj));
};

export default {
name: 'PopupPickerSelector',
props: {
arrow: String,
wider: false,
placeholder: String,
strictly: {
type: Boolean,
default() {
return false;
},
},
value: [String, Number, Boolean,null],
data: {
type: Array,
default() {
return [];
},
},
showName: Boolean,
disabled: {
type: Boolean,
default() {
return false;
}
}
},
data(){
return {
tempValue: [] ,
currentValue: [],
}
},
components: {
PopupPicker,
},
watch: {
value(val){
if (val && JSON.stringify([val]) !== JSON.stringify(this.tempValue)) {
this.tempValue = [val.toString()];
this.currentValue = [val.toString()];
}
}

},
methods: {
onChange(){
this.currentValue = this.tempValue[0];
this.$emit('input', this.currentValue);
this.$emit('on-change', this.currentValue);
}
},
mounted(){
if(this.strictly){

if(this.value == "" || this.value == null || this.value == undefined){
this.currentValue = this.tempValue = [];
}else{
this.currentValue = this.tempValue = [this.value.toString()];
}
}else{

if(this.value == null || this.value == undefined){
this.currentValue = this.tempValue = [];
}else{
this.currentValue = this.tempValue = [this.value.toString()];
}
}
}
}
